//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingChange_deploy_environment from './doingChange_deploy_environment';
import _doingNew_deploy_environment_onDemand from './doingNew_deploy_environment_onDemand';
import _doingValidate_deploy_environment from './doingValidate_deploy_environment';
import _willNew_deploy_environment from './willNew_deploy_environment';
export const doingChange_deploy_environment = _doingChange_deploy_environment;
export const doingNew_deploy_environment_onDemand = _doingNew_deploy_environment_onDemand;
export const doingValidate_deploy_environment = _doingValidate_deploy_environment;
export const willNew_deploy_environment = _willNew_deploy_environment;
export default {doingChange_deploy_environment, doingNew_deploy_environment_onDemand, doingValidate_deploy_environment, willNew_deploy_environment};

